import { useEffect, useRef, useState } from 'react'
import H from './Decoration/H'
import MarkDown from '~/components/Helpers/MarkDown'
import { cn } from '~/lib/utils'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const IntroText = ({ content, className, layoutColour }: any) => {
  const ref = useRef<HTMLDivElement>(null)
  const [dynamicH, setDynamicH] = useState(false)
  const colour =
    layoutColour === 'ink-blue' ||
    layoutColour === 'mid-blue' ||
    layoutColour === 'white' ||
    layoutColour === 'light-grey'
      ? content?.accentColour
      : 'ink-blue'

  useEffect(() => {
    // console.log(ref.current?.clientHeight)
    if (ref.current?.clientHeight && ref.current?.clientHeight > 100) {
      setDynamicH(true)
    }
  }, [ref])

  return (
    <div className={cn('relative max-w-[80ch]', className)}>
      <H bgColour={colour} compColour={null} dynamicH={dynamicH} />

      <div
        ref={ref}
        className={cn(
          dynamicH ? 'lg:ml-l ml-[40px] sm:ml-[44px]' : 'sm:ml-m ml-[28px]'
        )}
      >
        <MarkDown
          className='[&>p]:text-h4-sm sm:[&>p]:text-h4-md lg:[&>p]:text-h4-lg [&>p]:leading-[130%] [&>p]:font-normal'
          content={content.copy}
        />
      </div>
    </div>
  )
}

export default IntroText
